import { useDispatch, useSelector } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';

import { CountAmount, CountSelect, DownloadBtn, SettlementAmount, TotalAmount, CountAmountLeft } from '../component/btn/btn';
import List from '../component/list/list';
import { LoadingModal } from '../component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn } from '../component/search/search';
import { useNavigate } from 'react-router-dom';
import { changeNum } from '../common/function';
import dayjs from 'dayjs';

function SettlementVoucher() {
    let dispatch = useDispatch()
    let navigate = useNavigate();

    let MyData = useSelector((state) => { return state.MyData })

    const [page, setPage] = useState(1)
    const [maxFirstPage, setMaxFirstPage] = useState(40)
    const [amount, setAmount] = useState([1000000, 50000])
    const [loading, setLoading] = useState(true)
    const [spinner, setSpinner] = useState(false)

    const [listData, setListData] = useState([])
    const [listTrxData, setListTrxData] = useState([])
    const [combineData, setCombineData] = useState([])
    const [reload, setReload] = useState(false)
    const [amountResult, setAmountResult] = useState([])

    const checkBoxList = ["즉결", "익일"];
    const [checkBoxAmount, setCheckBoxAmount] = useState(checkBoxList); // ✅ 배열로 변경
    const hasToday = checkBoxAmount.includes("즉결");
    const hasNextday = checkBoxAmount.includes("익일");

    useEffect(() => {
        dispatch(change_Current_Location("바우처관리"))
        dispatch(changeHeaderTitle({
            mainTitle: "정산관리",
            subTitle: "바우처관리"
        }))

        setTimeout(() => {
            setLoading(false)
        }, 500)
    }, [])

    const handleChange = (event) => {
        setPage(1)
        setMaxFirstPage(Number(event.target.value));
    };

    // 기간 포맷
    const inputRef = useRef(null);
    const pickerRef = useRef(null); // Litepicker 인스턴스를 저장할 ref

    useEffect(() => {
        pickerRef.current = new Litepicker({
            element: inputRef.current,
            lang: "ko",
            singleMode: false, // 날짜 범위 선택
            format: 'YYYY-MM-DD', // 날짜 형식
            numberOfMonths: 2, // 두 달 표시
            numberOfColumns: 2, // 두 열로 나누어 표시
            showWeekNumbers: true, // 주 번호 표시
            dropdowns: {
                minYear: 2020,
                maxYear: 2030,
                months: true,
                years: true,
            },
            setup: (picker) => {
                // 이벤트 리스너 등록
                picker.on('selected', (start, end) => {
                    setPage(1)
                    setPreDate(start.format('YYYY-MM-DD'));
                    setNextDate(end.format('YYYY-MM-DD'));
                });
            }
        });

        return () => {
            pickerRef.current?.destroy(); // 컴포넌트 언마운트 시 파괴
        };
    }, []);

    // 날짜범위 포맷
    const [preDate, setPreDate] = useState()
    const [nextDate, setNextDate] = useState()

    useEffect(() => {
        setDateRange(dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'))
    }, [])

    // 날짜를 설정하는 함수
    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate)
        setNextDate(endDate)
        pickerRef.current?.setDateRange(startDate, endDate);
        onSubmitSearch()
    };

    const onSubmitSearch = () => {
        setPage(1)
        setReload(e => !e)
    }

    // 영업자 포맷
    const select1 = ["가맹점"]

    const [selectedValue, setSelectedValue] = useState("전체");
    const [selectedText, setSelectText] = useState("")

    const handleSelectChange = (event) => {
        const value = event.target.value;
        setSelectedValue(value);
    };

    const handleSelectTextChange = (event) => {
        const value = event.target.value;
        setSelectText(value);
    };

    useEffect(() => {
        // ListData()
    }, [page, maxFirstPage, reload, preDate, nextDate, checkBoxAmount])

    const ListData = async () => {
        if (page === 1) setSpinner(true)
        const tmpDate = new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0];
        await axios.get(process.env.REACT_APP_API + "/api/settlement/daily", {
            withCredentials: true,
            params: {
                page: page,
                limit: maxFirstPage,
                agentNm: selectedText,
                startDate: preDate ? preDate : tmpDate,
                endDate: nextDate ? nextDate : tmpDate,
                realtime: checkBoxAmount
            }
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                // console.log(tmp.data)
                setListData(tmp?.data ?? [])
                if (page === 1) {
                    setListTrxData(tmp?.data?.settlement ?? []);
                }
                else {
                    setListTrxData((prev) => [...prev, ...tmp?.data?.settlement ?? []]);
                }
                setAmountResult(tmp?.data?.stateSummary[0] ?? [])
            }
            else if (tmp?.code === 9999) {
                navigate('/')
            }
            setSpinner(false)
        }).catch(error => {
            console.error(error);
            navigate("/");
        });
    }

    const tableHeaderData = [
        { "no": 1, "text": "상태", "width": "50px", "textAlign": "center" },
        { "no": 2, "text": " 입금/출금일", "width": "120px", "textAlign": "center" },
        { "no": 3, "text": "가맹점명", "width": "150px", "textAlign": "center" },
        { "no": 4, "text": "입금/출금액", "width": "100px", "textAlign": "center" },
        { "no": 5, "text": "예금주명", "width": "100px", "textAlign": "center" },
        { "no": 6, "text": "은행명", "width": "100px", "textAlign": "center" },
        { "no": 7, "text": "계좌번호", "width": "130px", "textAlign": "center" },
    ];

    useEffect(() => {
        let tableBodyData = [];

        if (listTrxData) {
            let list = listTrxData ?? []

            for (let i = 0; i < list.length; i++) {
                let data = list[i]
                const upData = JSON.parse(data.up_data);
                tableBodyData.push([
                    { "no": 1, "text": "출금", "width": "50px", "textAlign": "center" },
                    { "no": 2, "text": data.mid, "width": "120px", "textAlign": "center" },
                    { "no": 3, "text": data.co_nm, "width": "150px", "textAlign": "left" },
                    { "no": 4, "text": data.realtime, "width": "100px", "textAlign": "center" },
                    { "no": 5, "text": data.accnt_nm, "width": "100px", "textAlign": "center" },
                    { "no": 6, "text": data.bank_nm, "width": "100px", "textAlign": "center" },
                    { "no": 7, "text": data.accnt_no, "width": "130px", "textAlign": "left" },
                ])
            }
            setCombineData(tableBodyData)
        }
    }, [listTrxData])

    // 더보기 버튼
    const [moreBtn, setMoreBtn] = useState(false)

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 640) setMoreBtn(true)
            else setMoreBtn(false)
        };

        window.addEventListener('resize', handleResize);
        handleResize()

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const observerRef = useRef(null);
    useEffect(() => {
        if (combineData.length === 0) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting && listData.totCnt >= page * maxFirstPage) {
                // 바닥에 닿으면 페이지 증가
                setPage((prev) => prev + 1);
            }
        });

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [combineData]);

    return (
        <div className="content" id="contents">
            {loading ? <LoadingModal /> : ""}
            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDate
                        type={"기간"}
                        inputRef={inputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                    />

                    {moreBtn && <SearchSelectText type={"영업자"} selectData={select1} handleSelectChange={handleSelectChange} selectedValue={selectedValue} handleSelectTextChange={handleSelectTextChange} selectedText={selectedText} btnText={"검색"} onClick={() => onSubmitSearch()} />}
                </form>
            </div>
            <div className="intro-y box intro-padding" >
                <div className="tabulator_sorting_wrap" style={{ flexDirection: "row", marginBottom: "10px" }}>
                    <div className="tabulator_summary_wrap" style={{ height: "auto", alignItems: 'flex-end', margin: "0", width: "100%", gap: "10px" }}>
                        <div className="input_wrap d_none" style={{ background: "#bdcdd6" }}>
                            <label>바우처잔액 :</label>
                            <input id="instant_terminal_amt" type="text" className="form-control" value={`0원`} readonly="" disabled="" />
                        </div>
                        <div className="input_wrap d_none" style={{ background: "#bdcdd6" }}>
                            <label>출금가능금액 :</label>
                            <input id="instant_terminal_amt" type="text" className="form-control" value={`0원`} readonly="" disabled="" />
                        </div>
                    </div>
                    <div className='excel-disable'>
                        <CountAmountLeft tableBodyData={listData?.totCnt ?? 0} textAlign={"right"} />
                    </div>
                </div>
                <div style={{ width: "100%", maxWidth: "900px" }}>
                    <List
                        tableHeaderData={tableHeaderData}
                        tableBodyData={listData?.totCnt ?? 0}
                        filter_tableBodyData={combineData}
                        page={page} setPage={setPage}
                        maxFirstPage={maxFirstPage}
                        observerRef={observerRef}
                        nonePage={false}
                        scrollState={true}
                        spinner={spinner}
                        height={"700px"}
                    />
                </div>
            </div>
        </div>
    )
}

const Excel = (excelData) => {
    const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const excelFileExtension = '.xlsx';
    const excelFileName = '가맹점 정산내역';

    const headerRow = [
        "정산일", "MID", "상호", "지사명", "총판명", "대리점명", "거래금액", "수수료",
        "정산금", "상계", "합계", "예금주명", "은행명", "계좌번호"
    ];

    const bodyRows = excelData.map((data) => ([
        data.정산일, data.MID, data.상호, data.지사명, data.총판명, data.대리점명,
        Number(data.거래금액), Number(data.수수료), Number(data.정산금),
        Number(data.상계), Number(data.합계), data.예금주명, data.은행명, data.계좌번호,
    ]));

    const sheetData = [headerRow, ...bodyRows];
    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    ws['!cols'] = Array(headerRow.length).fill({ wpx: 100 });

    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const excelFile = new Blob([excelBuffer], { type: excelFileType });

    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
};

export default SettlementVoucher